/**
 * Step8 Component: marchi
 */

import React, { Component } from "react";

import appStore from "../../../redux/store/appStore";
import { updateGui, updateConfiguration } from "../../../redux/actions/actions";

import Step from "./Step";
import StepRadioOptions from "./StepRadioOptions";

import {
    stepEditingDataId2CoreId,
    nextPermissionDeniedGuiFeedback,
} from "../../../helpers/wizard-helper";

import { getItem } from "../../../helpers/object-helper";

import "./Step8.css";
import StepSelectOptions from "./StepSelectOptions";

export const validateStep = options => {

    const parete = options.parete;
    const quantePareti = options.quantePareti;

    const pareteValid = parete !== null;
    const quanteParetiValid =
        parete === "no" || (quantePareti !== null && quantePareti !== "");

    return pareteValid && quanteParetiValid;

};

class Step8 extends Component {
    constructor(props) {

        super(props);
        
        this.stepNum = props.stepNum;

        this.stepConf = props.stepConf.parete;
        this.editingDataId = this.stepConf.dataId;
        this.options = this.stepConf.options;
        this.stepText = this.stepConf.text;

        this.confQuantePareti = props.stepConf.quantePareti;
        this.quanteParetiEditingDataId = this.confQuantePareti.dataId;
        this.quanteParetiOptions = this.confQuantePareti.options;
        this.quanteParetiText = this.confQuantePareti.text;

        this.isValidated = this.isValidated.bind(this);
        this.onOptionChange = this.onOptionChange.bind(this);
        this.onQuanteParetiChange = this.onQuanteParetiChange.bind(this);
        this.state = this.getInitialState(this.options, this.quanteParetiOptions);
    }

    componentDidMount() {
        appStore.dispatch(
            updateGui({
                currentEditingData: this.editingDataId,
            })
        );

        this.updateState('parete', this.getSelectedOptionValueFromStore());
        this.updateState('quantePareti', this.getSelectedQuanteParetiOptionValueFromStore());
    }

    /**
     * Returns the inital state
     * @param {Object[]} options
     *  [n]
     *      .label {String}
     *      .value {String}
     * @returns {Object}
     *  .parete {Object}
     *      .selectedOptionId {String}
     *      ... {Boolean}
     *  .quantePareti {Object}
     *      .selectedOptionId {String}
     *      ... {Boolean}
     */
    getInitialState(pareteOptions, quanteParetiOptions) {
        const state = {
            parete: {
                selectedOptionId: null
            },
            quantePareti: {
                selectedOptionId: null
            }
        };
        pareteOptions.forEach(option => {
            state.parete[option.value] = false;
        });
        quanteParetiOptions.forEach(option => {
            state.quantePareti[option.value] = false;
        });

        return state;
    }
 
    /**
     * Updates component state selecting selectedOptionId for state sliceId slice
     * @param {String} sliceId
     *  'parete'|'quantePareti'
     * @param {String} selectedOptionId
     */
    updateState(stateSliceId, selectedOptionId) {

        if (selectedOptionId === null) {
            return;
        }

        const initialState = this.getInitialState(this.options, this.quanteParetiOptions);

        const newState = {
            [stateSliceId]: {
                ...initialState[stateSliceId],
                [selectedOptionId]: true,
                selectedOptionId
            }
        }

        this.setState(() => newState);

    }

    /**
     * Step validation
     * @param {Boolean} showWarnMessage optional
     *  = undefined when call stack begins with btn next click, going through Stepzilla internals
     *      -> reacting to btn next click must show the warn message
     *  = Boolean (false) when call stack starts from Step.nextPermissionListener()
     *      -> reacting to redux store properties changes must not show the warn message
     */
    isValidated(showWarnMessage) {

        const valid = validateStep({
            parete: getItem(this.editingDataId, appStore.getState()),
            quantePareti: getItem(this.quanteParetiEditingDataId, appStore.getState())
        });

        if (!valid && showWarnMessage === undefined) {
            nextPermissionDeniedGuiFeedback(this, this.stepNum, true);
        }

        return valid;

    }

    /**
     * Returns from the store the value of the piece of data related to this step ('configuration.parete_cemento_pietra')
     * @return {HTMLElement|null}
     */
    getSelectedOptionValueFromStore() {
        return getItem(this.editingDataId, appStore.getState());
    }
 
    /**
     * Returns from the store the value of the piece of data related to 'configuration.quante_pareti_attraversare'
     * @return {HTMLElement|null}
     */
    getSelectedQuanteParetiOptionValueFromStore() {
        return getItem(this.quanteParetiEditingDataId, appStore.getState());
    };

    /**
     * On change event listener for radio option
     */
    onOptionChange(evt) {
        const optionValue = evt.target.value;
        this.updateState('parete', optionValue);

        appStore.dispatch(
            updateConfiguration({
                [stepEditingDataId2CoreId(this.editingDataId)]: optionValue,
            })
        );

        if (optionValue === "no") {
            appStore.dispatch(
                updateConfiguration({
                    [stepEditingDataId2CoreId(this.quanteParetiEditingDataId)]: null
                })
            );
        }

        this.isValidated();
    }

    onQuanteParetiChange(optionValue) {
        this.updateState('quantePareti', optionValue);

        appStore.dispatch(updateConfiguration({
            [stepEditingDataId2CoreId(this.quanteParetiEditingDataId)]: optionValue
        }));

        this.isValidated();
    }

    body() {
        return (
            <React.Fragment>
                <div
                    className={`slc-${stepEditingDataId2CoreId(
                        this.editingDataId
                    )}`}
                >
                    <StepRadioOptions
                        stepText={this.stepText}
                        name={this.editingDataId.split(".")[1]}
                        options={this.options}
                        interactionData={this.state.parete}
                        onOptionChange={this.onOptionChange}
                    />
                </div>
                {this.getSelectedOptionValueFromStore() === 'si' && (
                <div
                    className={`slc-${stepEditingDataId2CoreId(
                        this.quanteParetiEditingDataId
                    )}`}
                >
                    <StepSelectOptions
                        stepText={this.quanteParetiText}
                        options={this.quanteParetiOptions}
                        interactionData={this.state.quantePareti}
                        onOptionChange={this.onQuanteParetiChange}
                    />
                </div>
                )}
            </React.Fragment>
        );
    }

    render() {
        return (
            <Step
                stepComponent={this}
                stepNum={this.stepNum}
                stepBody={this.body()}
            />
        );
    }
}

export default Step8;
